exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7f6597d0] .el-tabs__content{height:calc(100% - 60px)!important}[data-v-7f6597d0] .el-input--mini .el-input__inner{height:28px!important}[data-v-7f6597d0] .el-form-item{margin-bottom:10px!important}", ""]);

// exports
